export default __webpack_public_path__ + "static/media/MoveItemIcon.3e9f81c9.svg";